export interface IPeriodInfo {
  year: number
  quarter: number
}

interface IGetYearAndQuarters {
  currentFYear: number
  currentFQuarter: number
  quartersBack: number
  includeCurrentQuarter?: boolean
}

export const getYearAndQuarters = ({
  currentFYear,
  currentFQuarter,
  quartersBack,
  includeCurrentQuarter = false,
}: IGetYearAndQuarters & { includeCurrentQuarter?: boolean }): IPeriodInfo[] => {
  const totalQuartersInYear = 4

  return Array.from({ length: quartersBack }, (_, index) => {
    const currentTotalQuarters =
      currentFYear * totalQuartersInYear + (currentFQuarter - (includeCurrentQuarter ? 0 : 1))
    const targetTotalQuarters = currentTotalQuarters - (quartersBack - 1 - index)
    const year = Math.floor((targetTotalQuarters - 1) / totalQuartersInYear)
    const quarter = ((targetTotalQuarters - 1) % totalQuartersInYear) + 1
    return { year, quarter }
  })
}
